import axios from "axios";

const axiosInstance = axios.create({
    baseURL: import.meta.env.VITE_BASE_URL,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
    },
    // withCredentials: true, // aktifkan kalau pakai cookie / auth session
});

export default axiosInstance;
